import Filter from "./Filter";
import FormData from "./FormData";
import NoEnterprise from "./NoEnterprise";
import ListData from "./ListData";
import TableData from "./TableData";

const enterprisesComponents = {
  Filter,
  FormData,
  NoEnterprise,
  ListData,
  TableData,
}

export default enterprisesComponents